import { render, staticRenderFns } from "./Amanah.vue?vue&type=template&id=b0e2eb74&scoped=true&"
import script from "./Amanah.vue?vue&type=script&lang=js&"
export * from "./Amanah.vue?vue&type=script&lang=js&"
import style0 from "./Amanah.vue?vue&type=style&index=0&id=b0e2eb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2eb74",
  null
  
)

export default component.exports